import React, { useCallback, useEffect, useRef, useState } from 'react'

import { useFileAuthMutation } from '@core/app/api/filePreviewApi'
import { useFilePreview } from '@core/utils/contexts/FilePreviewContext/FilePreviewContext'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import './FileUnsupportedPreview.scss'

const baseClass = 'FileUnsupportedPreview'

function FileUnsupportedPreview() {
    const { getTitle } = useApplyV2NavTranslations()
    const { previewFile, isOpen, closePreview, getFileName, fileExtension, folder } = useFilePreview()
    const containerRef = useRef<HTMLDivElement>(null)
    const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined)
    const [testBinaryRequest, { isLoading: isBinaryLoading }] = useFileAuthMutation()

    const handleKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                closePreview()
            }
        },
        [closePreview]
    )

    useEffect(() => {
        // console.log('FileImagePreview useEffect triggered:', { isOpen, previewFile })
        if (!previewFile?.Ext || !isOpen) return

        const loadImage = async () => {
            if (!previewFile?.CandidateFileID) {
                return
            }

            try {
                const response = await testBinaryRequest({
                    folder: folder ?? 'candidate_course',
                    fileId: previewFile.CandidateFileID,
                }).unwrap()

                console.log(response)

                // if (response.authUrl) {
                //     connectWebSocket(response)
                // }

                if (response.downloadUrl) {
                    // const validatedUrl = getValidatedImageUrl(response.downloadUrl)
                    // setImageUrl(validatedUrl || undefined)
                    setDownloadUrl(response.downloadUrl)
                }
            } catch (e) {
                console.error('download error', e)
            }
        }

        loadImage()
    }, [isOpen, previewFile, testBinaryRequest])

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown)
            document.body.style.overflow = 'hidden'
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.body.style.overflow = 'unset'
        }
    }, [isOpen, handleKeyDown])

    const lastModified = (() => {
        if (previewFile && 'lastModified' in previewFile) {
            return previewFile.lastModified || 0
        } else if (previewFile && 'uploaded' in previewFile) {
            const uploaded = Date.parse(previewFile.uploaded ?? '')
            return isNaN(uploaded) ? 0 : uploaded
        } else if (previewFile && 'Uploaded' in previewFile) {
            const uploaded = Date.parse(previewFile.Uploaded ?? '')
            return isNaN(uploaded) ? 0 : uploaded
        }
        return 0
    })()

    const formattedDate = lastModified
        ? new Date(lastModified).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
          })
        : ''

    const handleDownload = () => {
        // const validatedUrl = getValidatedImageUrl(downloadUrl)
        // console.log(validatedUrl, imageUrl)
        const downUrl = downloadUrl ?? previewFile?.downloadUrl ?? previewFile?.downloadLink
        console.log(downUrl)
        if (downUrl) {
            const link = document.createElement('a')
            link.href = downUrl
            link.download = getFileName() || 'image'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }

    return (
        <div className={`${baseClass} ${isOpen ? `${baseClass}--open` : ''}`}>
            <div className={`${baseClass}__header`}>
                <div className={`${baseClass}__header__left`}>
                    <div className={`${baseClass}__header__left__name`}>{getFileName()}</div>
                    <div className={`${baseClass}__header__left__date`}>{formattedDate}</div>
                </div>

                <div className={`${baseClass}__header__right`}>
                    {/*<div className={`${baseClass}__zoom`}>*/}
                    {/*    <button*/}
                    {/*        className={`${baseClass}__button ${baseClass}__zoom__button`}*/}
                    {/*        aria-label="zoom-decrease"*/}
                    {/*        onClick={() => handleZoomChange('decrease')}*/}
                    {/*        disabled={zoom <= 25}*/}
                    {/*    >*/}
                    {/*        <span>–</span>*/}
                    {/*    </button>*/}
                    {/*    <span>{zoom}%</span>*/}
                    {/*    <button*/}
                    {/*        className={`${baseClass}__button ${baseClass}__zoom__button`}*/}
                    {/*        aria-label="zoom-increase"*/}
                    {/*        onClick={() => handleZoomChange('increase')}*/}
                    {/*        disabled={zoom >= 200}*/}
                    {/*    >*/}
                    {/*        <span>+</span>*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    <div className={`${baseClass}__header__right__nav`}>
                        {/*<button*/}
                        {/*    className={`${baseClass}__button`}*/}
                        {/*    aria-label="print"*/}
                        {/*    onClick={() => {*/}
                        {/*        handlePrint(imageBlob)*/}
                        {/*    }}*/}
                        {/*    // disabled={!imageBlob}*/}
                        {/*>*/}
                        {/*    <span>{getTitle('1021', 'Print')}</span>*/}
                        {/*</button>*/}
                        <button
                            className={`${baseClass}__button`}
                            aria-label="download"
                            onClick={handleDownload}
                            // disabled={!imageUrl}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M12.9 3.5a.9.9 0 1 0-1.8 0v10.827l-2.464-2.463a.9.9 0 1 0-1.272 1.272l4 4a.9.9 0 0 0 1.272 0l4-4a.9.9 0 1 0-1.272-1.272L12.9 14.327zM2 16.6a.9.9 0 0 1 .9.9V19c0 .335.268.6.595.6h17.008a.597.597 0 0 0 .597-.6v-1.5a.9.9 0 1 1 1.8 0V19c0 1.323-1.068 2.4-2.396 2.4H3.495A2.396 2.396 0 0 1 1.1 19v-1.5a.9.9 0 0 1 .9-.9"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                            <span>{getTitle('2342', 'Download')}</span>
                        </button>
                    </div>
                    <button className={`${baseClass}__button`} onClick={closePreview} aria-label="Close preview">
                        <span>✕</span>
                    </button>
                </div>
            </div>
            <div className={`${baseClass}__content`} ref={containerRef}>
                {/*{isLoadingSpinner && <div className={`${baseClass}__content__spinner`} />}*/}
                <div className={`${baseClass}__image-container`}>
                    <div className={`${baseClass}__image-container--wrap`}>
                        <div>{getTitle('9351', 'Preview is not available')}</div>
                        <button
                            aria-label="download"
                            onClick={handleDownload}
                            className={`${baseClass}__image-container--wrap__download`}
                        >
                            {getTitle('2342', 'Download')}
                        </button>
                    </div>
                    {/*<img*/}
                    {/*    ref={imageRef}*/}
                    {/*    src={imageUrl}*/}
                    {/*    alt={getFileName() || 'Preview'}*/}
                    {/*    style={imageStyle}*/}
                    {/*    className={`${baseClass}__image`}*/}
                    {/*    onLoad={() => setImagesLoaded(true)}*/}
                    {/*/>*/}
                </div>
            </div>
        </div>
    )
}

export default FileUnsupportedPreview
